import { render, staticRenderFns } from "./ReceivingRequest.vue?vue&type=template&id=12bbcb2e&scoped=true"
import script from "./ReceivingRequest.vue?vue&type=script&lang=js"
export * from "./ReceivingRequest.vue?vue&type=script&lang=js"
import style0 from "./ReceivingRequest.vue?vue&type=style&index=0&id=12bbcb2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12bbcb2e",
  null
  
)

export default component.exports